var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFonticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 30,
    height: 30,
    rx: 2,
    stroke: "#222222",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6739 28H24.328V27.1314C23.9926 26.979 23.6068 26.8495 23.1708 26.7429C22.7515 26.6362 22.3238 26.5448 21.8878 26.4686V13.4857H24.806L26.4161 16.4419H27.4475L27.8249 14.7657C27.8752 14.2629 27.9171 13.7676 27.9507 13.28C27.9842 12.7924 28.001 12.3657 28.001 12H12.001C12.001 12.3505 12.0177 12.7771 12.0513 13.28C12.0848 13.7676 12.1268 14.2629 12.1771 14.7657L12.5544 16.4419H13.5859L15.1959 13.4857H18.1142V26.4686C17.6781 26.5295 17.2421 26.6286 16.806 26.7657C16.3867 26.8876 16.0094 27.0095 15.6739 27.1314V28Z",
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFonticon);
export default __webpack_public_path__ + "static/media/fonticon.b9db5d5fb2fb54c6a115c07d80e39107.svg";
export { ForwardRef as ReactComponent };